import dayjs from 'dayjs';
import moment from 'moment';
import PropTypes from 'prop-types';
import { enUS } from 'date-fns/locale';
import 'react-date-range/dist/styles.css';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/theme/default.css';

import { Stack, Paper, Typography } from '@mui/material';

import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

export default function CustomDateRangeInput({
  date = [
    {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endDate: new Date(),
      key: 'selection',
    },
  ],
  setDate,
  setFormattedDate,
}) {
  const popover = usePopover();

  return (
    <Stack mt={0} mr={1}>
      <Paper
        sx={{ padding: 0, minWidth: 170, width: '100%', margin: 0, border: '' }}
        className="custom-calender-new"
      >
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            border: '1px solid rgba(145, 158, 171, 0.2)',
            borderRadius: 1,
            padding: 0.4,
            cursor: 'pointer',
          }}
          onClick={popover?.onOpen}
        >
          <Stack mx={1} sx={{ cursor: 'pointer' }}>
            <Iconify icon="fluent:calendar-20-filled" width={16} />
          </Stack>
          <Stack width="100%" mr={1}>
            {date?.map((item, index) => (
              <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                key={index}
                spacing={0.5}
              >
                <Stack>
                  <Typography color="black" sx={{ fontSize: 13 }}>
                    {item?.startDate ? moment(item?.startDate).format('D/M/YYYY') : 'DD/MM/YYYY'}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography textAlign="center" color="black">
                    -
                  </Typography>
                </Stack>
                <Stack>
                  <Typography color="black" sx={{ fontSize: 13 }}>
                    {item?.endDate ? moment(item?.endDate).format('D/M/YYYY') : 'DD/MM/YYYY'}
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Paper>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ p: 0 }} arrow="top-right">
        <DateRange
          editableDateInputs
          onChange={(item) => {
            setDate([item.selection]);
            const selectedRangeFormatted = [item.selection]?.map((dates) => ({
              from: dayjs(dates?.startDate || new Date()).format('YYYY-MM-DD'),
              to: dayjs(dates?.endDate || new Date()).format('YYYY-MM-DD'),
            }));
            setFormattedDate(selectedRangeFormatted[0]);
          }}
          moveRangeOnFirstSelection
          ranges={
            date[0]?.startDate && date[0]?.endDate
              ? date
              : [
                  {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',
                  },
                ]
          }
          locale={enUS}
        />

        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={1}
          sx={{ p: 1, borderTop: '1px solid rgba(145, 158, 171, 0.2)' }}
        >
          <Typography
            variant="button"
            color="default.main"
            sx={{ cursor: 'pointer', opacity: 0.8 }}
            onClick={() => {
              setDate([
                {
                  startDate: '',
                  endDate: '',
                  key: 'selection',
                },
              ]);
              setFormattedDate();
            }}
          >
            Clear
          </Typography>
          <Iconify
            icon="mdi:clear"
            width={14}
            color="default.main"
            sx={{ cursor: 'pointer', opacity: 0.8 }}
            onClick={() => {
              setDate([
                {
                  startDate: '',
                  endDate: '',
                  key: 'selection',
                },
              ]);
              setFormattedDate();
            }}
          />
        </Stack>
      </CustomPopover>
    </Stack>
  );
}

CustomDateRangeInput.propTypes = {
  date: PropTypes.array,
  setDate: PropTypes.func,
  setFormattedDate: PropTypes.func,
};
